import React, { Component } from "react";
import * as log from "loglevel";

import  toastr  from 'COMPONENTS/ShowTostr/ShowTostr';
import {
  getUserName,
  getChatData,
  selectSessionKey,
  selectUniqueId,
  selectParticipantId
} from "../../Routes/selectors";

import { selectOrganiserParticipantId } from "REDUX/Selector/SessionSelector";

import Chat from "./Chat";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { addMessage } from "./ChatAction";
import { sessionActions as actionFactory } from "CONFIG/ActionFactory";
import { sendWebsocketMessage } from "WEBSOCKET/WebsocketHandler";

import { socketMessage } from "WEBSOCKET/constants";

import { selectChatMessages } from "./selectors";

import { getUserNameForSelectedLanguage } from "UTILS/Utility";

import { getMessage } from "CONFIG/i18n";

import moment from 'moment'

// CONSTANTS
import { downloadableModules} from "UTILS/Constants";
import { selectAllowedDownloads } from "../CommonComponents/Header/selectors";

class ChatContainer extends Component {
  constructor(props) {
    super(props);
  }

  sendChatMessage = chatMessage => {
    let timestamp = new Date();
    const { userName, sessionKey } = this.props;
    const message = {
      data: {
        category: socketMessage.category.CHAT,
        action: socketMessage.subCategories.CHAT.SEND_MESSAGE,
        sender: userName,
        sessionKey: sessionKey,
        message: chatMessage,
        participantId: this.props.participantId,
        timestamp: timestamp
      }
    };
    this.props.addMessage({
      sender: userName,
      message: chatMessage,
      ownMessage: true,
      timestamp: timestamp
    });
    this.props.sendWebsocketMessage(socketMessage.events.MESSAGE, message);
  };

  minimumTwoDigits = value => {
    return ("0" + value).slice(-2);
  };

  broadcastDownloadAction = (downloadType) => {
    const message = {
      data: {
        category: socketMessage.category.DOWNLOAD,
        action: socketMessage.subCategories.WHITEBOARD.OBJECT_DOWNLOADED,
        sessionKey: this.props.sessionKey,
        downloadType: downloadType
      }
    };
    this.props.sendWebsocketMessage(socketMessage.events.MESSAGE, message);
  };

  downloadChatMessages = () => {
    this.broadcastDownloadAction(downloadableModules.CHAT);
    let timestamp = new Date().getMilliseconds();
    actionFactory.downloadChatMessages(this.props.sessionKey, timestamp).then(
      data => {
        var textFile = null;
        var text = "";

        data.data.forEach(object => {
          let senderName = '';
          if(this.props.organiserParticipantId === object.participantId) {
            senderName = getUserNameForSelectedLanguage(this.props.language, object.sender);
          } else {
            senderName = getMessage(object.sender);
          }
          let d = new Date(object.timestamp);

          let time = moment(d).format('L HH:mm:ss')

          text =
            text +
            senderName +
            " @ " +
            time +
            " : " +
            object.message +
            "\r\n";
        });
        let fileText = new Blob([text], { type: "text/plain" });
        var isIE = /*@cc_on!@*/ false || !!document.documentMode;
        if (isIE) {
          navigator.msSaveBlob(fileText, "messages.txt");
        } else {
          textFile = window.URL.createObjectURL(fileText);

          let downloadElement = document.createElement("a");
          downloadElement.href = textFile;
          downloadElement.download = "messages.txt";
          downloadElement.click();
        }
      },
      error => {
        toastr.info(getMessage("DOWNLOAD_FAILED"));
        log.error("ERROR: ", error);
      }
    );
  };

  isChatDownloadAllowed = () => {
    return this.props.allowedDownloads && this.props.allowedDownloads.hasOwnProperty(downloadableModules.CHAT)
  }

  render() {
    return (
      <React.Fragment>
        <Chat
          sendChatMessage={this.sendChatMessage}
          userName={this.props.userName}
          chatPopOver={this.props.chatPopOver}
          chatMessages={this.props.chatMessages}
          handleClose={this.props.handleClose}
          downloadChatMessages={this.downloadChatMessages}
          isChatDownloadAllowed={this.isChatDownloadAllowed()}
          participantId={this.props.participantId}
          language={this.props.language}
          organiserParticipantId={this.props.organiserParticipantId}
        />
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    userName: getUserName(state),
    sessionKey: selectSessionKey(state),
    uniqueId: selectUniqueId(state),
    chatMessages: selectChatMessages(state),
    allowedDownloads: selectAllowedDownloads(state),
    participantId: selectParticipantId(state),
    language: state.LanguageReducer.language,
    organiserParticipantId: selectOrganiserParticipantId(state),
  };
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      sendWebsocketMessage: sendWebsocketMessage,
      addMessage: addMessage
    },
    dispatch
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ChatContainer);
